module.exports = __webpack_public_path__ + "static/media/hour-of-code-lesson-plan.44b3e797.webp";